<template>
    <div class="face">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h4 class="title1">易知鸟AI智能人脸识别系统</h4>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item1_list">
                        <div class="title">{{x.title}}</div>
                        <img :src='"/static/img/product_face/chanpin5_0"+(index+1)+".png"' alt="">
                    </li>
                </ul>
            </div>
        </div>

        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            item1_list: [
                { title: "精准识别"},
                { title: "拍照推送"},
                { title: "签到签退"},
                { title: "智能点名"},
                { title:"自动消课"},
                { title:"考勤通知"},
                { title:"语音播报"},
                { title:"老师考勤"},
            ],
            item2_list: [
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
                    this.$parent.$refs.openPop.openDialog(title,type);
                }
    }
}
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 480px;
    margin-top: 80px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/product_face/chanpin5_banner.jpg") no-repeat center;

    .banner-center {
        height: 100%;
        position: relative;
    }

    .banner-info {
        position: absolute;
        bottom: 120px;
        left:50px;
        text-align: left;
    }
    .shenqing{
        border: none;
        width: 180px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        color:#04162A;
        background: url(https://cdntest.yizhiniao.com/newWebsite_/product_face/chanpin5_anniu.png) no-repeat center;
        border-radius: 4px;
        &:hover,&:active{
            background: url(https://cdntest.yizhiniao.com/newWebsite_/product_face/chanpin5_anniu.png) no-repeat center;
            color:#04162A;
        }
    }
}

.item_1 {
        padding-top:160px;
        padding-bottom: 160px;
        .item-contents {
            margin-top: 60px;

            ul {
                width: 1130px;
                height: 620px;
                margin:0 auto;
                padding-top: 20px;
                padding-bottom: 20px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content:space-between;
                li {
                    width: 260px;
                    height: 260px;
                    padding: 40px 0 40px;
                    background: #F9FCFF;
                    border: 1px solid rgba(89, 112, 196, 0.2);

                    img {
                        width: 120px;
                        height: 120px;
                        margin: 32px auto 0px;
                    }

                    .title {
                        text-align: center;
                        font-weight: 500;
                        color: #646464;
                        height: 40px;
                        line-height: 40px;
                        font-size: 20px;

                    }
                    @keyframes fade-in {
                        0% {
                            width:0;
                        }/*初始状态 透明度为0*/
                        100% {
                            width: 100%;
                        }/*结束状态 透明度为1*/
                    }
                    @-webkit-keyframes fade-in {/*针对webkit内核*/
                        0% {
                            width:0;
                        }/*初始状态 透明度为0*/
                        100% {
                            width: 100%;
                        }/*结束状态 透明度为1*/
                    }

                    &:hover {
                        /* transition: 0.5s; */
                        background: #FFFFFF;
                        border:none;
                        box-shadow: 0px 2px 30px 0px rgba(191, 202, 214, 0.5);
                        .title{
                            color: #fff;
                            animation: fade-in;/*动画名称*/
                            animation-duration: .5s;/*动画持续时间*/
                            -webkit-animation:fade-in .5s;/*针对webkit内核*/
                            background: linear-gradient(174deg, #002273 0%, #074BB1 100%, #0042A5 100%);
                        }
                    }

                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/product_face.vue